import React from 'react'
import style from "./Property.module.css";

const Finance = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>항목/금융기관</p>
        <input type="text" name={`${key_name}_kind`} data-index={index} placeholder='주식/ NH투자증권' value={data?.kind} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>상세 내용</p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_detail`} data-index={index} placeholder='354,780,949원 (2019.5.31.현재)' value={data?.detail} onChange={handleInput}/>
        </div>
      </div>
    </div>
  )
}

export default Finance